import {
  ButtonClean,
  ExtendedChakraButtonProps
} from 'front-end/src/components'
import React, { FC } from 'react'
import { brandColors } from 'shared/basicPalette'

import { Trans } from '@lingui/macro'

interface TableExtendedPaginationProps {
  pageCurrent: number
  pageCount: number
  onPageChange: (page: number) => any
}

const filterPages = (visiblePages: number[], totalPages: number) => {
  return visiblePages.filter((page) => page <= totalPages)
}

const getVisiblePages = (activePage: number, numberOfPages: number) => {
  if (numberOfPages < 7) {
    return filterPages([1, 2, 3, 4, 5, 6], numberOfPages)
  }
  if (activePage % 5 >= 0 && activePage > 4 && activePage + 2 < numberOfPages) {
    return [1, activePage - 1, activePage, activePage + 1, numberOfPages]
  } else if (
    activePage % 5 >= 0 &&
    activePage > 4 &&
    activePage + 2 >= numberOfPages
  ) {
    return [
      1,
      numberOfPages - 3,
      numberOfPages - 2,
      numberOfPages - 1,
      numberOfPages
    ]
  } else {
    return [1, 2, 3, 4, 5, numberOfPages]
  }
}

const PagiButton: FC<ExtendedChakraButtonProps> = (props) => {
  const { ...rest } = props
  return (
    <ButtonClean
      p={props.isActive ? '0 8px 2px' : '0 8px'}
      minWidth="auto"
      height="20px"
      color={props.isActive ? brandColors.grey.dark : brandColors.grey[500]}
      fontWeight={props.isActive ? '900' : '400'}
      transform="none" // remove effect on isActive
      dataTest="PaginationButton"
      {...rest}
    />
  )
}

export const Pagination: FC<TableExtendedPaginationProps> = ({
  pageCurrent,
  pageCount,
  onPageChange: gotoPage
}) => {
  const visiblePages = getVisiblePages(pageCurrent, pageCount)

  return (
    <>
      <PagiButton
        disabled={pageCurrent === 1}
        onClick={() => gotoPage(pageCurrent - 1)}
      >
        <Trans>Prev</Trans>
      </PagiButton>

      {visiblePages.map((page, index, array) => {
        return (
          <PagiButton
            key={page}
            onClick={() => gotoPage(page)}
            isActive={pageCurrent === page}
          >
            {array[index - 1] + 2 < page ? `... ${page}` : page}
          </PagiButton>
        )
      })}
      <PagiButton
        disabled={pageCurrent === pageCount}
        onClick={() => gotoPage(pageCurrent + 1)}
      >
        <Trans>Next</Trans>
      </PagiButton>
    </>
  )
}
